import { AlertStatesBaseCountersModel } from './alert-states-base-counters-model';

export class AlertStatesInvalidStateReportCountersModel extends AlertStatesBaseCountersModel {
}
